// import { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useAuth } from '../context/AuthContext';
// import '../styles/style.css';

// export default function Login() {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [showPassword, setShowPassword] = useState(false);
//   const [error, setError] = useState('');
//   const [busy, setBusy] = useState(false);
//   const { login } = useAuth();
//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError('');
//     setBusy(true);
//     try {
//       await login(email, password);
//       navigate('/generate');
//     } catch (err) {
//       setError(err.response?.data?.message || 'Login failed');
//     } finally {
//       setBusy(false);
//     }
//   };

//   return (
//     <div className="login-page">
//       {/* ── Left: branding panel ── */}
//       <div className="brand-panel">
//         <div className="brand-glow" />

//         <div className="brand-content">
//           <div className="wordmark">HirePeaks</div>
//           <div className="eyebrow">OFFER LETTER SYSTEM</div>

//           <LetterSealGraphic />

//           <p className="tagline">
//             Every offer, drafted and sent with the same care it took to earn it.
//           </p>
//         </div>

//         <div className="brand-footer">
//           Internal tool · Authorized staff only
//         </div>
//       </div>

//       {/* ── Right: form panel ── */}
//       <div className="form-panel">
//         <form className="login-card" onSubmit={handleSubmit} noValidate>
//           <h1 className="login-title">Sign in</h1>
//           <p className="login-subtitle">Enter your credentials to continue</p>

//           {error && (
//             <div className="error-box" role="alert">
//               <ErrorIcon />
//               <span>{error}</span>
//             </div>
//           )}

//           <div className="field-group">
//             <label className="field-label" htmlFor="login-email">Email</label>
//             <input
//               id="login-email"
//               className="hp-input"
//               type="email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               placeholder="you@hirepeaks.com"
//               required
//               autoFocus
//               autoComplete="username"
//             />
//           </div>

//           <div className="field-group">
//             <label className="field-label" htmlFor="login-password">Password</label>
//             <div className="password-wrap">
//               <input
//                 id="login-password"
//                 className="hp-input hp-input--password"
//                 type={showPassword ? 'text' : 'password'}
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 placeholder="••••••••"
//                 required
//                 autoComplete="current-password"
//               />
//               <button
//                 type="button"
//                 onClick={() => setShowPassword((v) => !v)}
//                 aria-label={showPassword ? 'Hide password' : 'Show password'}
//                 className="hp-eye-btn"
//               >
//                 {showPassword ? <EyeOffIcon /> : <EyeIcon />}
//               </button>
//             </div>
//           </div>

//           <button type="submit" disabled={busy} className="hp-submit">
//             {busy ? (
//               <>
//                 <span className="hp-spinner" aria-hidden="true" />
//                 Signing in…
//               </>
//             ) : (
//               'Sign In'
//             )}
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// }

// // ── Signature element: a small illustrated letter with a wax seal —
// // a quiet, literal nod to "offer letters" rather than a generic gradient. ──
// function LetterSealGraphic() {
//   return (
//     <svg width="120" height="120" viewBox="0 0 120 120" fill="none" style={{ margin: '28px 0' }} aria-hidden="true">
//       <rect x="14" y="24" width="92" height="66" rx="6" fill="#1B3454" stroke="#2E4E75" strokeWidth="1.5" />
//       <line x1="28" y1="42" x2="80" y2="42" stroke="#3E6289" strokeWidth="2" strokeLinecap="round" />
//       <line x1="28" y1="52" x2="92" y2="52" stroke="#3E6289" strokeWidth="2" strokeLinecap="round" />
//       <line x1="28" y1="62" x2="70" y2="62" stroke="#3E6289" strokeWidth="2" strokeLinecap="round" />
//       <circle cx="88" cy="76" r="18" fill="#1F9BB4" />
//       <path d="M88 68 L91 74 L98 75 L93 80 L94 87 L88 84 L82 87 L83 80 L78 75 L85 74 Z" fill="#0E5B69" />
//     </svg>
//   );
// }

// function ErrorIcon() {
//   return (
//     <svg width="16" height="16" viewBox="0 0 20 20" fill="none" aria-hidden="true" style={{ flexShrink: 0 }}>
//       <circle cx="10" cy="10" r="9" stroke="#C0362A" strokeWidth="1.6" />
//       <line x1="10" y1="6" x2="10" y2="11" stroke="#C0362A" strokeWidth="1.6" strokeLinecap="round" />
//       <circle cx="10" cy="14" r="1" fill="#C0362A" />
//     </svg>
//   );
// }

// function EyeIcon() {
//   return (
//     <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
//       <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7Z" stroke="#64748B" strokeWidth="1.6" />
//       <circle cx="12" cy="12" r="3" stroke="#64748B" strokeWidth="1.6" />
//     </svg>
//   );
// }

// function EyeOffIcon() {
//   return (
//     <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
//       <path d="M3 3l18 18" stroke="#64748B" strokeWidth="1.6" strokeLinecap="round" />
//       <path d="M10.6 5.1A11 11 0 0 1 12 5c7 0 11 7 11 7a17.6 17.6 0 0 1-3.4 4.3M6.6 6.6C3.7 8.3 1 12 1 12s4 7 11 7a10.6 10.6 0 0 0 5-1.2" stroke="#64748B" strokeWidth="1.6" strokeLinecap="round" />
//       <path d="M9.5 9.6a3 3 0 0 0 4.2 4.2" stroke="#64748B" strokeWidth="1.6" strokeLinecap="round" />
//     </svg>
//   );
// }


import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/style.css';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await login(email, password);
      navigate('/generate');
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-page">
      {/* ── Left: branding panel ── */}
      <div className="brand-panel">
        <div className="brand-glow" />

        <div className="brand-content">
          <div className="wordmark">HirePeaks</div>
          <div className="eyebrow">OFFER LETTER SYSTEM</div>

          <LetterSealGraphic />

          <p className="tagline">
            Every offer, drafted and sent with the same care it took to earn it.
          </p>
        </div>

        <div className="brand-footer">
          Internal tool · Authorized staff only
        </div>
      </div>

      {/* ── Right: form panel ── */}
      <div className="form-panel">
        <form className="login-card" onSubmit={handleSubmit} noValidate>
          <h1 className="login-title">Sign in</h1>
          <p className="login-subtitle">Enter your credentials to continue</p>

          {error && (
            <div className="error-box" role="alert">
              <ErrorIcon />
              <span>{error}</span>
            </div>
          )}

          <div className="field-group">
            <label className="field-label" htmlFor="login-email">Email</label>
            <input
              id="login-email"
              className="hp-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@hirepeaks.com"
              required
              autoFocus
              autoComplete="username"
            />
          </div>

          <div className="field-group">
            <label className="field-label" htmlFor="login-password">Password</label>
            <div className="password-wrap">
              <input
                id="login-password"
                className="hp-input hp-input--password"
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                autoComplete="current-password"
              />
              <button
                type="button"
                onClick={() => setShowPassword((v) => !v)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
                className="hp-eye-btn"
              >
                {showPassword ? <EyeOffIcon /> : <EyeIcon />}
              </button>
            </div>
            <Link style={{color:'#3E6289'}} to="/forgot-password" className="forgot-password-link">
              Forgot password?
            </Link>
          </div>

          <button type="submit" disabled={busy} className="hp-submit">
            {busy ? (
              <>
                <span className="hp-spinner" aria-hidden="true" />
                Signing in…
              </>
            ) : (
              'Sign In'
            )}
          </button>
        </form>
      </div>
    </div>
  );
}

// ── Signature element: a small illustrated letter with a wax seal —
// a quiet, literal nod to "offer letters" rather than a generic gradient. ──
function LetterSealGraphic() {
  return (
    <svg width="120" height="120" viewBox="0 0 120 120" fill="none" style={{ margin: '28px 0' }} aria-hidden="true">
      <rect x="14" y="24" width="92" height="66" rx="6" fill="#1B3454" stroke="#2E4E75" strokeWidth="1.5" />
      <line x1="28" y1="42" x2="80" y2="42" stroke="#3E6289" strokeWidth="2" strokeLinecap="round" />
      <line x1="28" y1="52" x2="92" y2="52" stroke="#3E6289" strokeWidth="2" strokeLinecap="round" />
      <line x1="28" y1="62" x2="70" y2="62" stroke="#3E6289" strokeWidth="2" strokeLinecap="round" />
      <circle cx="88" cy="76" r="18" fill="#1F9BB4" />
      <path d="M88 68 L91 74 L98 75 L93 80 L94 87 L88 84 L82 87 L83 80 L78 75 L85 74 Z" fill="#0E5B69" />
    </svg>
  );
}

function ErrorIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 20 20" fill="none" aria-hidden="true" style={{ flexShrink: 0 }}>
      <circle cx="10" cy="10" r="9" stroke="#C0362A" strokeWidth="1.6" />
      <line x1="10" y1="6" x2="10" y2="11" stroke="#C0362A" strokeWidth="1.6" strokeLinecap="round" />
      <circle cx="10" cy="14" r="1" fill="#C0362A" />
    </svg>
  );
}

function EyeIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7Z" stroke="#64748B" strokeWidth="1.6" />
      <circle cx="12" cy="12" r="3" stroke="#64748B" strokeWidth="1.6" />
    </svg>
  );
}

function EyeOffIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M3 3l18 18" stroke="#64748B" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M10.6 5.1A11 11 0 0 1 12 5c7 0 11 7 11 7a17.6 17.6 0 0 1-3.4 4.3M6.6 6.6C3.7 8.3 1 12 1 12s4 7 11 7a10.6 10.6 0 0 0 5-1.2" stroke="#64748B" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M9.5 9.6a3 3 0 0 0 4.2 4.2" stroke="#64748B" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}
